/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Casedatasectionhomeowner3Inputs */

const en_casedatasectionhomeowner3 = /** @type {(inputs: Casedatasectionhomeowner3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About you`)
};

const pt_casedatasectionhomeowner3 = /** @type {(inputs: Casedatasectionhomeowner3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre si`)
};

/**
* | output |
* | --- |
* | "About you" |
*
* @param {Casedatasectionhomeowner3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const casedatasectionhomeowner3 = /** @type {((inputs?: Casedatasectionhomeowner3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Casedatasectionhomeowner3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_casedatasectionhomeowner3(inputs)
	return pt_casedatasectionhomeowner3(inputs)
});
export { casedatasectionhomeowner3 as "caseDataSectionHomeowner" }